// extracted by css-extract-rspack-plugin
export default {"scholarshipDesktopContainer":"ScholarshipDesktop-module__scholarshipDesktopContainer","sectionSeparator":"ScholarshipDesktop-module__sectionSeparator"};